import type {
  AppRouter,
  RouterInputs as AppRouterInputs,
  RouterOutputs as AppRouterOutputs,
} from "@rivaled/api/src/router.js";
import { createTRPCReact } from "@trpc/react-query";

export const trpc = createTRPCReact<AppRouter>();

export type RouterInputs = AppRouterInputs;
export type RouterOutputs = AppRouterOutputs;
